import { FC } from 'react';
import { IFicoDetails } from './CreditReport/interfaces/interfaces';

export const FicoDetails: FC<IFicoDetails> = ({ ficoDetails }) => (
  <>
    {ficoDetails?.map((fico, index) => (
      <div key={index}>
        {fico.name}/{fico.scoreType} {fico.score}
      </div>
    ))}
  </>
);
